import React from 'react';
import '../../styles/App.css';
import '../../styles/Table.css'

/**
 * Class used for rendering and handling complete history for NAO Vehicles
 *
 *
 * @author Ethan Jones
 */
class CompleteHistory extends React.Component{


    state = {
        hwd: false,
        hwdId: null,
        hwdIndex: null,
        hwdCopMap: null,
        isHwdMap: null,
        isHwdCopMap: false,
        hardwareStateList: null
    }

    /**
     * Method used for iterating through all chain of parts for controller and display them
     * @returns {*}
     */
    renderCompleteHistory(){

        return(
            <div>
                <label className={"complHistoryLabel"}>Calibration History</label>
                {this.props.modules.map((data, index)=>(
                    <div>
                        <label className={"CompleteHistoryChildLabel"}>
                            {data[1]}
                        </label>
                    <table className={"CompleteHistoryChild"}>
                        <tr>
                            <th>Part Number</th>
                            <th>CVN</th>
                            <th>Bulletin Number</th>
                            <th>Descriptions</th>
                        </tr>
                            {this.props.chainOfParts[data[0]].map((cop, index)=>(
                                <tr>
                                    <td>{cop[0]}</td>
                                    <td>{this.props.progSeqData.cvnMap[cop[0]]}</td>
                                    <td>{cop[1] === "0"?("-"):(cop[1])}</td>
                                    <td>{cop[2]}</td>
                                </tr>
                            ))}
                    </table>
                    </div>
                ))}
            </div>
        )
    }

    /**
     * Method used for iterating through complete history when hardware dependencies are involved
     * @returns {*}
     */
    renderCompleteHistoryHWD(){
        return(
            <div>
                {this.props.modules.map((data, index)=>(
                    <div>
                    <label className={"CompleteHistoryChildLabel"}>
                        {data[1] + " Calibration History"}
                    </label>
                    <table className={"CompleteHistoryChild"}>
                        <tr>
                            <th>Part Number</th>
                            <th>CVN</th>
                            <th>Bulletin Number</th>
                            <th>Descriptions</th>
                        </tr>
                        {this.props.progSeqData.dependencyDataExists[data[0]] ? (
                            <React.Fragment>
                            {this.props.progSeqData.dependencyDataCopMap[data[0]] &&
                             this.props.progSeqData.dependencyDataCopMap[data[0]][this.props.hardwareId] &&
                             this.props.progSeqData.dependencyDataCopMap[data[0]][this.props.hardwareId].map((cop, index1) => (
                                 <tr>
                                     <td>{cop[0]}</td>
                                     <td>{this.props.progSeqData.cvnMap[cop[0]]}</td>
                                     <td>{cop[1] === "0" ? ("-") : (cop[1])}</td>
                                     <td>{cop[2]}</td>
                                 </tr>
                             ))}
                            </React.Fragment>
                        ):(
                            <React.Fragment>
                            {this.props.chainOfParts[data[0]].map((cop, index)=>(
                                <tr>
                                    <td>{cop[0]}</td>
                                    <td>{this.props.progSeqData.cvnMap[cop[0]]}</td>
                                    <td>{cop[1] === "0"?("-"):(cop[1])}</td>
                                    <td>{cop[2]}</td>
                                </tr>
                            ))}
                            </React.Fragment>
                        )}

                    </table>
                    </div>
                ))}
            </div>
        )
    }

    /**
     * Main render method for NAOVin complete history
     * @returns {*[]}
     */
    render() {
        return [
            <div>
                {this.props.hardwareId === -1 || this.props.progSeqData.isNaoCalDataPartDecision !== undefined ? (
                    this.renderCompleteHistory()
                ) : (
                    <React.Fragment>
                        {this.renderCompleteHistoryHWD()}
                    </React.Fragment>
                )}
            </div>
        ]
    }
}

export default CompleteHistory;